"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var utils_1 = require("./utils");
var FieldArray = /** @class */ (function () {
    function FieldArray(name) {
        this.attachCount = 1;
        this.subFields = mobx_1.observable([]);
        this.errors = [];
        this.update(name);
    }
    FieldArray.prototype.update = function (name) {
        this.name = name;
    };
    Object.defineProperty(FieldArray.prototype, "attached", {
        get: function () {
            return this.attachCount > 0;
        },
        enumerable: true,
        configurable: true
    });
    FieldArray.prototype.addField = function (field) {
        var fieldPath = utils_1.objectPath(field.name);
        var lastPathNode = fieldPath[fieldPath.length - 1];
        // When lastPathNode is numeric this means that in FormArray we register a direct children on FormArray
        if (utils_1.isNumeric(lastPathNode)) {
            this.subFields[parseInt(lastPathNode, 10)] = field;
        }
        // we registering a Field in childrend on FormArray, like Field in a FieldSection
        // todo: clarify when this condition fires
        else {
            var preLastPathNode = parseInt(fieldPath[fieldPath.length - 2], 10);
            if (!this.subFields[preLastPathNode]) {
                throw new Error("Attempt to register field named \"" + lastPathNode + "\" without registring its parent first.\n\t\t\t\t\tProbably you should refactor your <Control name=\"[index]" + lastPathNode + "\" /> into\n\t\t\t\t\t<ControlSection name={index} component={...}> and <Control name=\"" + lastPathNode + "\" /> as component");
            }
            this.subFields[preLastPathNode][lastPathNode] = field;
        }
    };
    FieldArray.prototype.reset = function () {
        this.subFields.forEach(function (subField) { return subField.detach(); });
        this.subFields.clear();
    };
    FieldArray.prototype.setTouched = function () {
        this.subFields.forEach(function (subField) { return subField.setTouched(); });
    };
    FieldArray.prototype.removeField = function (index) {
        this.subFields.splice(parseInt(index, 10), 1);
    };
    FieldArray.prototype.getField = function (index) {
        // Avoid mobx.js:1905 [mobx.array] Attempt to read an array index (0) that is out of bounds (0).
        // Please check length first. Out of bound indices will not be tracked by MobX
        return (this.subFields.length > parseInt(index, 10)) ? this.subFields[index] : undefined;
    };
    FieldArray.prototype.detach = function () {
        if (this.attached) {
            this.attachCount = this.attachCount - 1;
        }
        this.subFields.forEach(function (subField) { return subField.detach(); });
    };
    Object.defineProperty(FieldArray.prototype, "realSubFields", {
        get: function () {
            // filter in order to avoid errors when subFields has a gap for item to be inserted
            // tslint:disable-next-line:max-line-length
            return this.subFields.filter(function (subField) { return subField && subField.attached; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldArray.prototype, "value", {
        get: function () {
            return this.realSubFields.map(function (subField) { return subField.value; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldArray.prototype, "rules", {
        get: function () {
            return this.realSubFields.reduce(function (rules, subField) {
                if (subField.attached) {
                    Object.assign(rules, subField.rules);
                }
                return rules;
            }, {});
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldArray.prototype, "isDirty", {
        get: function () {
            return this.realSubFields.some(function (subField) { return subField.isDirty; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], FieldArray.prototype, "attachCount", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], FieldArray.prototype, "errors", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], FieldArray.prototype, "attached", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FieldArray.prototype, "addField", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FieldArray.prototype, "reset", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FieldArray.prototype, "setTouched", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], FieldArray.prototype, "removeField", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], FieldArray.prototype, "realSubFields", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FieldArray.prototype, "value", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], FieldArray.prototype, "rules", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], FieldArray.prototype, "isDirty", null);
    return FieldArray;
}());
exports.FieldArray = FieldArray;
//# sourceMappingURL=FieldArray.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/FieldArray.js
// module id = 128
// module chunks = 0